import { useState } from 'react';
import CustomModal from '../../Shared/CustomModal/CustomModal';
import NewsCarousel from './NewsCarousel';
import './NewsContainer.scss';
interface INewsContainerProps {
  content: any;
}
const NewsContainer = (props: INewsContainerProps) => {
  const { content } = props;
  const [readMoreModalProps, setReadMoreModalProps] = useState({
    isModalOpen: false,
  });
  const createModalContent = (payload: any) => {
    return (
      <div className="ma-3">
        <p className="Home_News_Card_Title">{payload?.title}</p>
        <p className="Home_News_Card_Subtitle">
          <span
            dangerouslySetInnerHTML={{
              __html: payload?.content,
            }}
          />
        </p>
      </div>
    );
  };
  const handleReadMore = (payload: any) => {
    const temp = {
      isModalOpen: true,
      closeModalAction: () => setReadMoreModalProps({ isModalOpen: false }),
      contentAlignment: 'left',
      additionalCssClass: 'Modal_ReadMore',
      size: 'large',
      closeBtn: true,
      backdropDismiss: true,
      children: createModalContent(payload),
    };
    setReadMoreModalProps(temp);
  };
  return (
    <div className="NewsContainer" data-testid="NewsContainer">
      <CustomModal {...readMoreModalProps} />
      <div className={`Home_News_Container`}>
        {content?.map((news: any, index: any) => {
          return (
            <NewsCarousel
              news={news}
              index={index}
              key={news?.value + index}
              handleReadMore={handleReadMore}
            />
          );
        })}
      </div>
    </div>
  );
};
export default NewsContainer;
